import { IGetNewKeyForPositionUpdating, IGetTooltipDimensions, TooltipPosition } from "./../libs/NewTooltip/types";

// This Function is got key for a position. And checks  Is the tooltip in the window.
const windowSpacing = 32;
const tooltipSpacingOfElement = 22;
export const getNewKeyForPositionUpdating: IGetNewKeyForPositionUpdating = ({
    initialPosition,
    tooltipContainer,
    tooltipDimensions,
}) => {
    if (tooltipDimensions.current && tooltipContainer.current) {
        const { x, y, height, width } = tooltipContainer.current.getBoundingClientRect();
        const { height: tooltipHeight, width: tooltipWidth } = tooltipDimensions.current;

        let key: string = TooltipPosition[initialPosition];

        const startX = windowSpacing;
        const endX = window.innerWidth - windowSpacing;
        const startY = windowSpacing;
        const endY = window.innerHeight - windowSpacing;

        if (x + width - (tooltipSpacingOfElement + tooltipWidth) < startX) key = key.replace("LEFT", "RIGHT");
        else if (x + tooltipWidth > endX) key = key.replace("RIGHT", "LEFT");

        if (y - (tooltipSpacingOfElement + tooltipHeight) < startY) key = key.replace("TOP", "BOTTOM");
        else if (y + height + tooltipSpacingOfElement + tooltipHeight > endY) key = key.replace("BOTTOM", "TOP");

        return key;
    } else {
        return "";
    }
};

export const getTooltipDimensions: IGetTooltipDimensions =
    ({ changeTooltipRef, tooltipDimensions }) =>
    e => {
        if (e) {
            // Transfer the tooltip element to the tooltip ref.
            changeTooltipRef(e);
            const { offsetWidth, offsetHeight } = e;
            // for css calculation.
            e.style.setProperty("--tooltipWidth", `${offsetWidth}px`);
            e.style.setProperty("--tooltipHeight", `${offsetHeight}px`);

            if (tooltipDimensions.current) {
                tooltipDimensions.current.width = offsetWidth;
                tooltipDimensions.current.height = offsetHeight;
            }
        }
    };
